import { render, staticRenderFns } from "./mainTittle.vue?vue&type=template&id=55fb5cf4&scoped=true&"
import script from "./mainTittle.vue?vue&type=script&lang=js&"
export * from "./mainTittle.vue?vue&type=script&lang=js&"
import style0 from "./mainTittle.vue?vue&type=style&index=0&id=55fb5cf4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb5cf4",
  null
  
)

export default component.exports